import { render, staticRenderFns } from "./uCatalogueItem.vue?vue&type=template&id=fdec2aa0&scoped=true&"
import script from "./uCatalogueItem.vue?vue&type=script&lang=js&"
export * from "./uCatalogueItem.vue?vue&type=script&lang=js&"
import style0 from "./uCatalogueItem.vue?vue&type=style&index=0&id=fdec2aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdec2aa0",
  null
  
)

export default component.exports